const addHtmlAttribute = (attribute: string, key: string) => {
  if (key) {
    document.querySelector('html').setAttribute(attribute, key);
  }
};

export const isDevelopment = process.env.NODE_ENV === 'development';

export default addHtmlAttribute;
